module.exports = __webpack_public_path__ + "img/14.06b710fe.png";